import React from 'react';
import styles from '../../../styles/ViewListing.module.css';
import type { ListingClient, ListingClientDocument } from '../../../types/ListingTypes';
import { downloadFile } from '../../../utils/fileUtils';

interface DetailProps {
    clients: ListingClient[];
}

const ClientDetails: React.FC<DetailProps> = ({ clients }) => {
  return (
    <section className={styles.section}>
      <p className={styles.sectionTitle}>Clients</p>
      {clients.length === 0 ? (
        <p className={styles.empty}>No clients added yet.</p>
      ) : (
        <div className={styles.clientGrid}>
          {clients.map((client: ListingClient) => {
            const initials =
              `${(client.name ?? '').charAt(0)}${(client.surname ?? '').charAt(0)}`.toUpperCase();

            const addressLine = [
              client.streetNumber ? `${client.streetNumber} ${client.streetName}` : client.streetName,
              client.city,
              client.province,
              client.postalCode,
            ].filter(Boolean).join(', ');

            return (
              <div key={client.id} className={styles.clientCard}>
                {/* Name + role */}
                <div className={styles.clientCardHeader}>
                  <div className={styles.clientAvatar}>{initials}</div>
                  <div className={styles.clientCardMeta}>
                    <span className={styles.clientName}>{client.name} {client.surname}</span>
                    {client.clientType && (
                      <span className={styles.clientRole}>{client.clientType.name}</span>
                    )}
                  </div>
                </div>

                {/* Contact */}
                {(client.email || client.cell) && (
                  <div className={styles.clientContact}>
                    {client.email && (
                      <div className={styles.clientContactRow}>
                        <span className={styles.clientContactIcon}>✉️</span>
                        <span>{client.email}</span>
                      </div>
                    )}
                    {client.cell && (
                      <div className={styles.clientContactRow}>
                        <span className={styles.clientContactIcon}>📞</span>
                        <span>{client.cell}</span>
                      </div>
                    )}
                  </div>
                )}

                {/* Address */}
                {addressLine && (
                  <p className={styles.clientAddress}>{addressLine}</p>
                )}

                {/* Client documents */}
                {client.documents && client.documents.length > 0 && (
                  <div className={styles.clientDocs}>
                    <span className={styles.clientDocsTitle}>Documents</span>
                    {client.documents.map((doc: ListingClientDocument) => (
                      <div key={doc.id} className={styles.clientDocRow}>
                        <span className={styles.clientDocName}>{doc.name}</span>
                        {doc.url && (
                          <button
                            className={styles.downloadBtn}
                            onClick={e => { e.stopPropagation(); downloadFile(doc.url!, doc.name); }}
                            title="Download"
                          >
                            ↓
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default ClientDetails;
